import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=5376f0dd&scoped=true&"
import script from "./FlipCard.vue?vue&type=script&lang=ts&"
export * from "./FlipCard.vue?vue&type=script&lang=ts&"
import style0 from "./FlipCard.vue?vue&type=style&index=0&id=5376f0dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5376f0dd",
  null
  
)

export default component.exports